module.exports = __webpack_public_path__ + "img/bed-3.0b1a16bd.svg";